import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import * as Actions from 'actions';

class PassResetEmailNotification extends React.Component {
	constructor(props) {
		super(props);

		this.handleResendEmail = this.handleResendEmail.bind(this)
	}

	handleResendEmail() {
		if(this.props.tmp_user && this.props.tmp_user.email) {
			this.props.beginPasswordReset(this.props.tmp_user.email)
		}
		else
			console.log('ERROR : No email stored')
	}

	render() {
    return (
    	<section className='body-sign lost-password-container'>
        <div className='center-sign'>
          <a href='/' className='logo pull-left'>
            <img src='assets/images/logo-default.png' height='54' alt='Hailtrace App' />
          </a>
          <div className='panel panel-sign'>
            <div className='panel-title-sign mt-xl text-right'>
              <h2 className='title text-uppercase text-weight-bold m-none'><i className='fa fa-user mr-xs'></i> Sign In</h2>
            </div>
            <div className='panel-body'>
							<div className='form-group mb-lg'>
								<div className='row'>
									<div className='col-md-12'>
										<div className='alert alert-info'>
											{(() => {
												if(this.props.users.tmp_user && this.props.users.tmp_user.email)
													return (
														<p>
															An email has been sent to {this.props.users.tmp_user.email}. 
															Please check your email to reset your password.
														</p>
													)
											})()}
										</div>
									</div>
								</div>
								<div className='row'>
									<div className='col-md-12'>
										<p>
											<a onClick={this.handleResendEmail}><strong>Click Here</strong></a> to resend the email.
										</p>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
    );
  }
}

export default connect(({users}) => ({users}), Actions)(PassResetEmailNotification)



// WEBPACK FOOTER //
// ./src/browser/components/sales/passResetEmailNotification.js